import { withIfUser } from '@app/components/common/Routes';
import { hasPermissions } from '@app/utils';
import ReceivableList from '@app/views/Ledger/ReceivableList';
import { memo } from 'react';

export default memo(
  withIfUser(ReceivableList)({
    condition: ({ roles }) => roles.some(hasPermissions),
    redirect: true,
    redirectTo: '/unauthorized',
  })
);
